"use client";

import Image from "next/image";
import React from "react";
import layerblur from "@/assets/whoweare/Lyer blur.svg";
import outlook from "@/assets/whoweare/4th-outlook 1.svg";

const WhoweBanner = () => {
  return (
    <div className="w-full bg-white mt-14 mb-14 grid grid-cols-1 xl:grid-cols-2 overflow-hidden">
      {/* Left image side */}
      <div className="relative w-full h-48 sm:h-60 md:h-64 lg:h-72 xl:h-[252px] flex items-center justify-center">
        <Image
          src={layerblur}
          alt="layer blur"
          fill
          className="object-cover"
          priority
        />
        <Image
          src={outlook}
          alt="outlook 4th banner"
          fill
          className="object-contain px-6 sm:px-10"
          priority
        />
      </div>

      {/* Right text side */}
      <div className="bg-[#0062b8] text-white flex items-center px-6 sm:px-10 py-6">
        <p
          className="text-base sm:text-lg md:text-[20px] leading-relaxed"
          style={{ fontFamily: "saans-medium" }}
        >
          Medhavi Skills University has been awarded the 4th position in the Outlook
          ICARE Rankings of Skills Universities across India, a proud achievement
          that underlines our commitment to quality and practice-driven
          education.
        </p>
      </div>
    </div>
  );
};

export default WhoweBanner;